var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCreate)?_c('skud-visit-form'):_c('skud-visit-view')}
var staticRenderFns = []

export { render, staticRenderFns }